import { render, staticRenderFns } from "./DriverNewPage.vue?vue&type=template&id=f55f7dba&"
import script from "./DriverNewPage.vue?vue&type=script&lang=js&"
export * from "./DriverNewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports